import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { ApiError, apiClient } from '@/lib/api-client';

/** An account holding an operator role — ADR-0063 decision 5. */
export interface Operator {
  id: number;
  email: string | null;
  role: 'admin' | 'support' | 'user';
}

export const operatorKeys = {
  all: ['operators'] as const,
};

/**
 * GET /admin/operators — who can sign in to this dashboard.
 *
 * Read-only by design, and there is no mutation hook beside it on purpose: role changes go
 * through the `grant:operator` command (ADR-0063), because an endpoint that mints operators
 * would turn a stolen dashboard session into persistence.
 */
export function useOperators(): UseQueryResult<Operator[], ApiError> {
  return useQuery({
    queryKey: operatorKeys.all,
    queryFn: ({ signal }) => apiClient.get<Operator[]>('/admin/operators', signal),
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
}
